import React, { useMemo } from 'react';
import { DataTable } from '@onward-delivery/design';
import { childColumns } from './columns';
import { useSkuItems } from './hooks';
import { filterItemsByFacet } from './utils';
import ItemStatusLegend from './ItemStatusLegend';

const SkuItemsTable = ({ row, accountType, itemIds = null, facet = null, selectedFacetIds = [] }) => {
    const { items, loading, error } = useSkuItems(row?.sku);
    const columns = useMemo(() => childColumns(accountType), [accountType]);

    // Only narrowed when the parent row is here *because* of an item match, so
    // an empty result means the search genuinely hit nothing in this SKU rather
    // than that no search is running.
    // Both narrowings apply. The facet one is local because these rows are
    // already loaded; without it, filtering to one carrier would show a
    // matching SKU whose expanded list is full of another carrier's items.
    const visible = useMemo(() => {
        const searched = itemIds ? items.filter((item) => itemIds.has(item.item_id)) : items;
        return filterItemsByFacet(searched, facet, selectedFacetIds);
    }, [items, itemIds, facet, selectedFacetIds]);

    if (error) {
        return <div className="px-3 py-2 text-sm text-destructive">Items for this SKU could not be loaded.</div>;
    }

    return (
        <div>
            {/* Counts come off the already-loaded parent row, so the legend does
                not flicker while the item query is in flight. */}
            <ItemStatusLegend row={row} />
            <DataTable
                columns={columns}
                data={visible}
                getRowId={(item) => item.item_id}
                isLoading={loading}
                emptyState={
                    itemIds || selectedFacetIds.length ? 'No matching items in this SKU' : 'No items for this SKU'
                }
                virtualized
            />
        </div>
    );
};

export default SkuItemsTable;
